import React, {useState} from 'react';
import '../view-archer-styles.css';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, MenuItem, InputLabel, Select, Stack } from '@mui/material/';

//const data
import DataBindingSources from '../data/DataBindingSources';

interface DataBindingDialogProps {
    isDataBindingDialogOpen: boolean,
    closeDataBindingDialog: () => void,
    getDataBindingValue: (value: string) => void
}

const IssueDataBindingDialog = (props: DataBindingDialogProps) => {

    //initial state set up
    const [dataType, setDataType] = useState('filer');
    const [itemType, setItemType] = useState('Filer.CpfId');
    const [itemOptions, setItemOptions] = useState(DataBindingSources.Filer);

    const updateDataType = (event: any) => {
        setDataType(event.target.value);
        switch (event.target.value) {
            case 'filer':
                setItemOptions(DataBindingSources.Filer);
                setItemType(DataBindingSources.Filer[0].value);
                break;
            case 'item':
                setItemOptions(DataBindingSources.Item);
                setItemType(DataBindingSources.Item[0].value);
                break;
            case 'report':
                setItemOptions(DataBindingSources.Report);
                setItemType(DataBindingSources.Report[0].value);
                break;
            case 'letter':
                setItemOptions(DataBindingSources.Letter);
                setItemType(DataBindingSources.Letter[0].value);
                break;
            case 'issue':
                setItemOptions(DataBindingSources.Issue);
                setItemType(DataBindingSources.Issue[0].value);
                break;
        }
    }

    const updateItemType = (event: any) => {
        setItemType(event.target.value);
    }

    const getDataBindingValue = () => {
        props.getDataBindingValue(itemType);
    }

    return (
        <>
            <Dialog
                open={props.isDataBindingDialogOpen}
                onClose={props.closeDataBindingDialog}
            >
                <DialogTitle>Insert Data Binding...</DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Stack direction="row" spacing={1} sx={{ marginTop: 1 }}>
                            <FormControl sx={{ m: 1, minWidth: 180 }} size="small">
                                <InputLabel>Data Type</InputLabel>
                                <Select
                                    defaultValue='filer'
                                    label="Data Type"
                                    onChange={(event) => updateDataType(event)}
                                >
                                    <MenuItem value='filer'>Filer</MenuItem>
                                    <MenuItem value='item'>Item</MenuItem>
                                    <MenuItem value='report'>Report</MenuItem>
                                    <MenuItem value='letter'>Letter</MenuItem>
                                    <MenuItem value='issue'>Issue</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl sx={{ m: 1, minWidth: 180 }} size="small">
                                <InputLabel>Item Description</InputLabel>
                                <Select
                                    defaultValue={itemType}
                                    label="Item Description"
                                    onChange={(event) => updateItemType(event)}
                                >
                                    {
                                        itemOptions.map((option) =>
                                            <MenuItem key={option.value} value={option.value} >{option.description}</MenuItem>
                                            )
                                    }
                                </Select>
                            </FormControl>
                        </Stack>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.closeDataBindingDialog}>Cancel</Button>
                    <Button onClick={getDataBindingValue}>Insert</Button>
                </DialogActions>
            </Dialog>
        </>
    )

}

export default IssueDataBindingDialog;